import { HttpErrorResponse } from '@angular/common/http';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { Router, NavigationEnd } from '@angular/router';
import { debounceTime, filter } from 'rxjs/operators';
import { RfqCacheService } from 'src/app/views/dashboard/rfq-cache.service';
import {
  AbstractControl,
  FormBuilder,
  FormArray,
  FormControl,
  FormGroup,
  NgForm,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { SearchService } from 'src/app/views/search/search/search.service';
import { SettingsService } from 'src/app/views/settings/settings.service';
import { Observable, Subject, Subscription } from 'rxjs';
import { Page } from 'src/app/shared/models/page';
import {
  aboutDataType,
  AutoCompleteDataType,
  AutoCompleteSupplierProduct,
  Currency,
  quoteAttachmentType,
  quoteDeclineReasonType,
  incoterms,
  offeredQuality,
  portData,
  supplierBranchData,
  Vessel,
} from 'src/app/shared/models/settings.model';
import { FullLoaderService } from 'src/app/shared/services/full-loader.service';
import { CookieService } from 'ngx-cookie-service';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
// import { SupplierService } from '../../supplier/supplier-dashboard/supplier-dashboard.service';
import { SupplierService } from '../../dashboard/supplier/supplier-dashboard/supplier-dashboard.service';
import { SupplierService as ss } from 'src/app/views/settings/suppliers/supplier.service';
import { Supplier } from 'src/app/shared/models/supplier.model';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { LocalStoreService } from 'src/app/shared/services/local-store.service';
import { QuoteService } from '../../dashboard/quote/quote.service';
import { RfqGenerateFormService } from '../../dashboard/rfq/rfq-generate-form/rfq-genearte-form.service';
import { NgxFileDropEntry } from 'ngx-file-drop';
import { MatSelectChange } from '@angular/material/select';
import { v4 as uuidv4 } from 'uuid';
import { WebApiService } from 'src/app/shared/services/web-api.service';
import { AwsSdkService } from 'src/app/shared/services/aws-sdk.service';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { BuyerService } from 'src/app/views/settings/buyers/buyer.service';
import { AttachmentTypes } from 'src/app/shared/common/Enums';
import { MatRadioChange } from '@angular/material/radio';
import { DataTransferService } from 'src/app/shared/services/data-transfer.service';
import { PurchaseOrderService } from 'src/app/views/operations/purchase-order/purchase-order.service';
import moment from 'moment';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { InvoiceService } from '../create-invoice/invoice-service';
import { MatCheckboxChange } from '@angular/material/checkbox';
// import * as html2pdf from 'html2pdf.js';


interface Attachment {
  name: string;
  systemName: string;
  fileKey: string;
  s3_path: string;
}


interface Location {
  locationId: number;
  locationName: string;
  code: string;
}

interface Incoterm {
  incotermId: number;
  incotermCode: string;
  userId: number;
  locationDetails: Location[];
}



@Component({
  selector: 'app-create-dispatch',
  templateUrl: './create-dispatch.component.html',
  styleUrls: ['./create-dispatch.component.css']
})
export class CreateDispatchComponent implements OnInit {
  @ViewChild('table') table!: DatatableComponent;
  @ViewChild('pdfContent') contentToPrint!: ElementRef<HTMLDivElement>;
  rfqId!: number;
  quoteId!: number;
  purchaseOrderId!: number;
  invoiceId!: number;
  dispatchId:any;
  userId!: number;
  isSaved: boolean = false;
  currentTab: string = 'preview';
  tabEnabled: boolean = false;

  showConfirmationDialogue: boolean = false;
  showSuccessDialogue: boolean = false;
  showCloseDialogue: boolean = false;
  previewSection: boolean = false;
  previewDocs: any[] = [];
  currentIndex = 0;

  showAddDispatchRequirement:boolean=false
  selectedType:string=''
  showNewType:boolean=true
  typeName:string=''

  showAcceptOrder: boolean = false;
  showRejectOrder: boolean = false;
  showOrderConfirmed: boolean = false;


  freightValues: any[] = [];
  availableModes: any[] = [];



  showNotification: boolean = false;
  notificationMessage: string = '';
  notificationTitle: string = '';
  notificationType: 'error' | 'info' = 'error';



  selectedAttachmentType!: number | null;
  hazardousDeclaration!: number | null;
  newfileuploaded: boolean = false;
  uploadedAttachmentsArray: any[] = [];
  acceptedAttachmentExtenstion: any = ['.pdf', '.jpg', '.jpeg', '.png'];
  maxFileSize: number = 10 * 1024 * 1024; //10MB

  currentdate = new Date();



  isForm1Expand: boolean = true;
  isForm2Expand: boolean = true;
  isForm3Expand: boolean = true;




  lastId!: number;
  headerAttachmentUrl: any;
  headerAttachmentSection: boolean = false;
  paymentTermsAndConditionsSection: boolean = false;
  buyerAttachmentsSection: boolean = false;
  paymentTermsAndConditions: any;
  paymentTermsAndConditionAttachmentUrl: any;
  buyerAttachmentUrl: string[] = [];
  incoterms: incoterms[] = [];
  offeredQualityData: offeredQuality[] = [];
  headerAttachmentType: quoteAttachmentType[] = [];
  lineItemAttachmentType: quoteAttachmentType[] = [];






  // countries: Countries[] = [];
  countries: any[] = [];
  filteredCountries: any[] = [];
  selectedCountries: any[] = [];
  incotermLocationList: any[] = [];


  dispatchFormGroup!: UntypedFormGroup;
  requirementsFormGroup!: UntypedFormGroup;


  incotermLocations: string = '';

  incotermsCode: number | null = null;


  uploadedAdditionalAttachmentsArray: any[] = [];


  dispatchRequirementList: any[] = []
  requirementTypes: any[] = []
  typeData: any[] = []
  minDate: Date = new Date();
  selectedRequirements:number[]=[]

   // tooltip text not provided
  orderDetailsTooltip = `Order Details`
  freightTooltip = `Freight Forwarder Details`
  documentTooltip = `Upload Documents`
  createDeliveryRequirementTooltip = `• As a supplier, you can create new delivery requirements specific to the products.
  • Be sure to select the relevant requirement before submitting.`




  constructor(
    private snack: MatSnackBar,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private rfqCacheService: RfqCacheService,
    private _formBuilder: UntypedFormBuilder,
    private cdr: ChangeDetectorRef,
    private searchService: SearchService,
    private SettingsService: SettingsService,
    private fullLoaderService: FullLoaderService,
    private supplierService: SupplierService,
    private ss: ss,
    public dialog: MatDialog,
    private ls: LocalStoreService,
    private quoteService: QuoteService,
    private RfqGenerateFormService: RfqGenerateFormService,
    private cookieService: CookieService,
    private webApiService: WebApiService,
    private awsSdkService: AwsSdkService,
    private CookieService: CookieService,
    private dataTransferService: DataTransferService<any>,
    private purchaseOrderService: PurchaseOrderService,
    private route: ActivatedRoute,
    private invoiceService: InvoiceService

  ) {

  }

  async ngOnInit() {


    this.dispatchFormGroup = this._formBuilder.group({
      dispatchId: [null],
      rfqId: [null],
      quoteId: [null],
      invoiceId: [null],
      poId: [null],
      rfqRefNumber: [''],
      quoteRefNumber: [''],
      poRefNumber: [''],
      invoiceRefNumber: [''],
      supplierDispatchRefNumber: [''],
      incoterms: [''],
      dispatchDate: [''],
      freightForwarderId: [''],
      freightForwarder: [''],
      modeOfTransport: [''],
      awbNumber: ['',[
        Validators.pattern(/^\d{3}-\d{8}$/)
      ]],
      trackingLink: ['', [
        Validators.pattern(/^(https?:\/\/)([\w-]+\.)+[\w-]+(\/[\w- ./?%&=]*)?$/)
      ]],
      dispatchAttachments:[],
      supplierId: Number(this.cookieService.get('userId'))
    });

    this.requirementsFormGroup = this._formBuilder.group({
      requirementType: [null, Validators.required],
      typeName: [null],
      requirementName: [null,Validators.required],
      requirementDescription: [null,Validators.required]
     
    });

    this.fetchAllDispatchRequirements()
    this.fetchAllModeofTransport()

    this.incoterms =  await this.quoteService.fetchAllIncoterms();


    this.activatedRoute.queryParams.subscribe(async params => {


      if (params['invoiceId'] != '' && params['dispatchId'] != '' ) {

        this.invoiceId = params['invoiceId']
        this.dispatchId = params['dispatchId']

        if (this.dispatchId != 'new') {
          this.isSaved = true

          this.fetchDispatchData()
          this.dispatchFormGroup.disable()
         
        }
        else if (this.dispatchId == 'new') {
          this.fullLoaderService.showLoader()
          this.invoiceService.fetchInvoiceDataById(Number(this.invoiceId))
            .then((data) => {
               
              if (data && data.length > 0){

                
                this.dispatchFormGroup.patchValue({

                rfqId: data[0].rfqId,
                quoteId: data[0].quoteId,
                invoiceId: data[0].invoiceId,
                poId: data[0].poId,
                rfqRefNumber: data[0].rfqRefNumber,
                quoteRefNumber: data[0].quoteRefNumber,
                poRefNumber: data[0].purchaseOrderRefNumber,
                invoiceRefNumber: data[0].invoiceNumber,
                dispatchDate:new Date(),
                incoterms: data[0].incotermsId,
                // freightForwarderId: null,
                freightForwarder: data[0].freightForwarderCompanyName,

              });

              }

            

            })
          
         
          this.fullLoaderService.hideLoader()
        }

      }


    })


    this.route.queryParams.subscribe((params) => {
      const poId = params['poId'];
      const rfqId = params['rfqId'];
      const quoteId = params['quoteId'];
      const poStatusValue = params['poStatusValue'];

      console.log('CreateInvoiceComponent -> query params:', params);
      console.log('CreateInvoiceComponent -> IDs:', {
        poId,
        rfqId,
        quoteId,
        poStatusValue,
      });
    });

    this.dispatchFormGroup.get('incoterms')?.disable();
  }

  toggleVisibility(section: string) {

    if (section == 'form1') {
      this.isForm1Expand = !this.isForm1Expand;
    } else if (section == 'form2') {
      this.isForm2Expand = !this.isForm2Expand;
    } else if (section == 'form3') {
      this.isForm3Expand = !this.isForm3Expand;
    }
  }

  async save(isDraft?: boolean) {
    console.log('INSIDE SAVE');
    this.fullLoaderService.showLoader();

    if (isDraft) {
      this.showConfirmationDialogue = false;
      this.showCloseDialogue = false;
    }

    // const params = {
    //   section: 'preview',
    //   purchaseOrderStatus: isDraft ? 14 : 3,
    //   purchaseOrderTabId: 4,
    //   quoteId: this.quoteId,
    //   userId: Number(this.cookieService.get('userId')),
    //   purchaseOrderId: this.purchaseOrderId,
    //   termsConditionsAttachment:
    //     this.paymentFormGroup.get('attachments')?.value,
    //   rfqId: this.rfqId,
    // };

    // const result = await this.purchaseOrderService.updatePurchaseOrder(params);
    // this.fullLoaderService.hideLoader();
    // if (!isDraft) {
    //   setTimeout(() => {
    //     this.router.navigate(['dashboard', 'supplier']);
    //   }, 3000); // 3000 milliseconds = 3 seconds
    // }
  }



  async back() {

  }

  async next() {

  }








  allowOnlyLetters(event: KeyboardEvent) {
    const charCode = event.key.charCodeAt(0);
    // Allow A-Z, a-z and space
    if (
      !(charCode >= 65 && charCode <= 90) && // uppercase letters
      !(charCode >= 97 && charCode <= 122) && // lowercase letters
      !(charCode === 32) // space
    ) {
      event.preventDefault();
    }
  }


















  async close(isDraft: boolean) {
    if (!isDraft) {
      this.showConfirmationDialogue = true;
    } else {
      this.router.navigate(['operations', 'supplier-purchase-order-list']);
    }
  }

  cancel() {
    this.showConfirmationDialogue = false;
    this.showCloseDialogue = false;
    this.showAcceptOrder = false;
    this.showRejectOrder = false;
    this.showOrderConfirmed = false;
  }





  fileOver(event: any) { }
  fileLeave(event: any) { }

  async onAttachmentChange(files: NgxFileDropEntry[], attachmentType:string) {
    
    
    this.fullLoaderService.showLoader();
    this.uploadedAttachmentsArray =
    this.dispatchFormGroup.get('dispatchAttachments')?.value || [];
    
    
    // if (this.uploadedAttachmentsArray.length > 5) {
    //   throw new Error('Maximum 5 files allowed for a product!');
    // }

    const fileEntries = files
      .filter((entry) => entry.fileEntry.isFile)
      .map((ele) => ele.fileEntry as FileSystemFileEntry);

      console.log(fileEntries,"fileEntries")

    if (fileEntries.length === 0) {
      this.snack.open('Please upload valid files!', 'OK', { duration: 3000 });
      this.fullLoaderService.hideLoader();
      return; 
      // throw new Error('Please upload valid files!');
    }
    if (fileEntries.length > 5) {
      // throw new Error('Maximum 5 files allowed for a product!');
      this.snack.open('Maximum 5 files allowed!', 'OK', { duration: 3000 });
      this.fullLoaderService.hideLoader();
      return; 
    }

    await new Promise((res, rej) => {
      fileEntries.map((fileEntry) => {
        fileEntry.file(async(file) => {
          let fileExt = file.name.split('.').pop();
          if (!this.acceptedAttachmentExtenstion.includes(`.${fileExt}`)) {
            // rej('Invalid filetype!');
            this.snack.open('Invalid filetype!', 'OK', { duration: 3000 });
            this.fullLoaderService.hideLoader();
            return; 
          }
          

          if (file.size > this.maxFileSize) {
            this.snack.open('File size must be less than 5MB!', 'OK', { duration: 3000 });
            this.fullLoaderService.hideLoader();
            return; 
            // throw new Error('File size must be less than 5MB!')
          }

          let uploadedAttachment:any = {
            dataUrl:'',
            name:file.name,
            file:file,
            attachmentType: attachmentType
          }

          await new Promise((res,rej)=>{
            const reader = new FileReader();
            reader.onload = (e: any) => {
              uploadedAttachment.dataUrl = e.target.result; // Store the data URL for preview
              res(true)
            };
            reader.readAsDataURL(file); // Read the file as a data URL
          })

          this.uploadedAttachmentsArray.push(uploadedAttachment);
          res(file);
        });
      });
    });

    this.dispatchFormGroup.get('dispatchAttachments')?.setValue(this.uploadedAttachmentsArray);

    console.log("dispatchAttachments",this.uploadedAttachmentsArray);
    this.fullLoaderService.hideLoader();

  } catch (error: any) {
    this.snack.open(error, 'OK', { duration: 3000 });
    this.fullLoaderService.hideLoader();
  
  }

  // onDeclineReasonChange(event: MatSelectChange) {
  //   const selectedValue = event.value;

  //   if (selectedValue == '7') {
  //     this.showOtherReason = true;
  //   } else {
  //     this.showOtherReason = false;
  //   }
  // }




  // Function to display the notification with missing fields
  showMissingFieldsNotification(
    missingFields: { section: string; fields: string[] }[]
  ) {
    let message =
      '<strong>Please fill all the missing fields before proceeding:</strong><br><br>';

    // Loop through each section and list its missing fields
    missingFields.forEach((missingField) => {
      message += `<strong>${missingField.section}:</strong><br>`; // Add section name
      message += missingField.fields
        .map((field) => `  • ${field}`)
        .join('<br>'); // List missing fields with bullet points
      message += '<br><br>'; // Add extra spacing between sections
    });

    this.notificationMessage = message;
    this.notificationTitle = 'Missing Fields';
    this.notificationType = 'error'; // Change this to 'info' for informational notifications
    this.showNotification = true; // Display the notification
  }



  isValidRequiredFields(): { section: string; fields: string[] }[] {
    const missingFields: { section: string; fields: string[] }[] = [];



    return missingFields;
  }


  nextSlide() {
    this.currentIndex = (this.currentIndex + 1) % this.previewDocs.length;
  }

  prevSlide() {
    this.currentIndex =
      (this.currentIndex - 1 + this.previewDocs.length) % this.previewDocs.length;
  }

  async togglePreview(value: boolean, section: string) {
    
    this.currentIndex = 0;

    if (value) {
      if (section == 'additionalDocument') {
          this.previewDocs = this.uploadedAttachmentsArray.filter(item => item.attachmentType === 'additionalDocument');
        } 
      else if(section == 'proofOfPickup') {
        this.previewDocs = this.uploadedAttachmentsArray.filter(item => item.attachmentType === 'proofOfPickup');
      }
    } else {
      this.previewDocs = [];
    }
    console.log('previewDoc', this.previewDocs,  this.previewDocs[this.currentIndex]);
    this.previewSection = value;
  }



  async onAddtionalFileSelected(files: NgxFileDropEntry[]) {
    try {
      this.fullLoaderService.showLoader();
      this.uploadedAdditionalAttachmentsArray = [];

      if (this.uploadedAdditionalAttachmentsArray.length > 5) {
        throw new Error('Maximum 5 files allowed for a product!');
      }

      const fileEntries = files
        .filter((entry) => entry.fileEntry.isFile)
        .map((ele) => ele.fileEntry as FileSystemFileEntry);

      console.log(fileEntries, 'fileEntries');

      if (fileEntries.length === 0) {
        throw new Error('Please upload valid files!');
      }
      if (fileEntries.length > 5) {
        throw new Error('Maximum 5 files allowed for a product!');
      }

      await new Promise((res, rej) => {
        fileEntries.map((fileEntry) => {
          fileEntry.file(async (file) => {
            let fileExt = file.name.split('.').pop();
            if (!this.acceptedAttachmentExtenstion.includes(`.${fileExt}`)) {
              // rej('Invalid filetype!');
              return;
            }

            if (file.size > this.maxFileSize) {
              throw new Error('File size must be less than 5MB!');
            }

            let uploadedAttachment: any = {
              dataUrl: '',
              name: file.name,
              file: file,
            };

            await new Promise((res, rej) => {
              const reader = new FileReader();
              reader.onload = (e: any) => {
                uploadedAttachment.dataUrl = e.target.result; // Store the data URL for preview
                res(true);
              };
              reader.readAsDataURL(file); // Read the file as a data URL
            });

            this.uploadedAdditionalAttachmentsArray.push(uploadedAttachment);
            res(file);
          });
        });
      });

      // this.paymentFormGroup
      //   .get('attachments')
      //   ?.setValue(this.uploadedAdditionalAttachmentsArray);
      this.fullLoaderService.hideLoader();
    } catch (error: any) {
      this.snack.open(error, 'OK', {
        duration: 1000,
      });
    }
  }

  openFileSelector() { }

  async submit() {
    // if (!isDraft) {
    //   this.showConfirmationDialogue = true;
    // } else {
    //   this.showCloseDialogue = true;
    // }

    this.fullLoaderService.showLoader();

    
    if(this.getProofOfPickupAttachment().length  == 0){
      this.snack.open(`Proof of Pickup document is required.`, "OK", { duration: 3000 });
      this.fullLoaderService.hideLoader();
      return;
    }

    if(!this.dispatchFormGroup.valid){
      this.snack.open(`Invalid form.`, "OK", { duration: 3000 });
      this.fullLoaderService.hideLoader();
      return;
    }

    const dateString1 = this.dispatchFormGroup.value.dispatchDate ? moment(this.dispatchFormGroup.value.dispatchDate).format("YYYY-MM-DDTHH:mm:ss") + "Z" : null;

    this.dispatchFormGroup.patchValue({
      dispatchDate: dateString1,
      supplierId: Number(this.cookieService.get('userId'))
    });

    
    let formData = this.dispatchFormGroup.getRawValue();

    console.log("submit data",formData);
     
    formData.selectedRequirementId = this.selectedRequirements


    let attachmentFiles:any = {} 

    // let formObj = this.dispatchFormGroup.value;
    let formObj = this.dispatchFormGroup.getRawValue();
    formObj.selectedRequirementId = this.selectedRequirements
    
    console.log("formObj",formObj);
    let attachmentArray = [...this.uploadedAttachmentsArray]

    attachmentArray = attachmentArray.filter(item=>item.file)
          
    // generate the s3 upload content for each attachment file
    let uploadPath = `dispatch/${this.dispatchFormGroup.get('invoiceId')?.value}`
      
      await Promise.all(attachmentArray.map(async(attachment:any,index:any)=>{
        if(!attachment.file){
              return
        }

            let fileName = attachment.file.name
            let fileExt = attachment.name.slice(
              ((attachment.name.lastIndexOf('.') - 1) >>> 0) + 2
            );
            
            let fileNameSystem = `${uuidv4()}.${fileExt}`

            attachment.systemName = fileNameSystem //This name denotes the fileNames for our system records
            let s3Location = `${uploadPath}/${fileName}`; //!this location to be verified before starting upload
      
            let _s3Params = {
              fileKey: s3Location,
              fileContentType: (<File>attachment.file).type,
            };
            attachment.s3Params = _s3Params
            attachmentFiles[attachment.file.name] = attachment.file
      }))

          console.log({attachmentArray});
          // get presigned urls for all the attachments in bulk
          formObj.dispatchAttachments = await this.SettingsService.getBulkAttachmentUrls(attachmentArray);
          console.log("dispatchAttachement",formObj.dispatchAttachements);

          formObj.dispatchAttachments.map(async(attachment:any)=>{
            attachment.s3_path = this.awsSdkService.extractS3LocationFromUrl(attachment.s3_path)
            attachment.fileKey = attachment.s3Params?.fileKey
          })

          console.log("dispatchAttachement after s3_path extraction",formObj.dispatchAttachements);

          // upload all the iamges to s3 bucket
          await Promise.all(formObj.dispatchAttachments.map(async (attachment:any)=>{
            this.webApiService.putRequestExternalApi(attachment.s3_path, attachmentFiles[attachment.name])
          }))
		  
		  
          
		  
		  if (this.dispatchId == 'new' && this.dispatchFormGroup.get('dispatchId')?.value == null) {
  
       
        // if(!formData.dispatchAttachments){
        //   formData.dispatchAttachments = [];
        //   console.log("Check dispatchAttachement",formObj.dispatchAttachements);
        // }
        // const result = await this.invoiceService.createDispatch(formData);

        const result = await this.invoiceService.createDispatch(formObj);
  
  
        if (result?.data) {
  
          this.fullLoaderService.hideLoader()
  
          this.snack.open(`Dispatch submitted successfully`, "OK", { duration: 3000 });
  
          this.isSaved = true;
  
          this.dispatchId = result.data

          this.router.navigate(['/operations/invoice-list']);
  
         
  
  
        } else {
          this.fullLoaderService.hideLoader()
          throw new Error('Invalid response format: Expected { data: number }');
        }
  
      }
      else if (this.dispatchId != 'new' &&
        this.dispatchFormGroup.get('dispatchId')?.value 
  
      ) {
  
        
  
      }


   
    this.fullLoaderService.hideLoader();
    // if (!isDraft) {
    //   setTimeout(() => {
    //     this.router.navigate(['dashboard', 'supplier']);
    //   }, 3000); // 3000 milliseconds = 3 seconds
    // }
    
  }

  toggleBlur(): void {
    const element = document.querySelector('.blurry');
    if (element) {
      element.classList.toggle('blur');
    } else {
      console.warn('Element with class "blurry" not found.');
    }
  }

  isPdf(urlOrDataUrl: string): boolean {
    if (urlOrDataUrl?.toLowerCase().startsWith('data:application/pdf')) {
      return true; // For data URLs, check if the MIME type is 'application/pdf'
    }
    return urlOrDataUrl?.toLowerCase().endsWith('.pdf'); // For URLs, check if it ends with '.pdf'
  }


  async closeCreateDispatchPage() {
    this.router.navigate(['/operations/invoice-list']);
  }

  dismissNotification() {
    this.showNotification = false;
  }

  getRequirementsByType(type: string) {
    return this.dispatchRequirementList.filter(r => r.requirementType === type);
  }

  toggleSidebar(value:boolean, section:string){
    if(section == 'requirementForm'){
      this.showAddDispatchRequirement = value
    }
   
  }

  onTypeChange(event: MatSelectChange) {
    const selectedValue = event.value;

    if (selectedValue == 'other') {
      this.showNewType = true;
    } else {
      this.showNewType = false;
    }
  }

  async createDispatchRequirement() {
    this.fullLoaderService.showLoader()
    
    if(this.requirementsFormGroup.valid){
      await this.SettingsService.createDispatchRequirement(
        this.requirementsFormGroup.value
      );
      this.snack.open('Dispatch requirement created successfully.', 'OK', {
        duration: 3000,
      });
      this.showAddDispatchRequirement = false
      this.requirementsFormGroup.reset()
      this.fullLoaderService.hideLoader()
      this.fetchAllDispatchRequirements()
    }
    else{
      this.snack.open('Invalid fields.', 'OK', {
        duration: 3000,
      });
      this.fullLoaderService.hideLoader()
    }
    

  }


  async fetchAllDispatchRequirements(){

    this.fullLoaderService.showLoader()

    this.dispatchRequirementList = await this.SettingsService.fetchAllDispatchRequirements();
  
    this.fullLoaderService.hideLoader()

    this.requirementTypes = [...new Set(this.dispatchRequirementList.map(r => r.requirementType))];
  
    this.typeData =   [
      ...this.requirementTypes.map(item => ({
        name: item,
        label: item.charAt(0).toUpperCase() + item.slice(1).toLowerCase()
      })),
      // { name: 'other', label: 'Other' }  
    ];
  }


  async fetchAllModeofTransport(){
    const result = await this.SettingsService.fetchAllModeOfTransport();
    this.availableModes = result;
  }


  onSelectDeselctRequirements(event: MatCheckboxChange, requirementId: number): void {
   

    const exists = this.selectedRequirements.includes(requirementId)

    if (!exists) {
      this.selectedRequirements.push(requirementId)
    }
    else {
      this.selectedRequirements = this.selectedRequirements.filter(v => v !== requirementId);
    }

    console.log(this.selectedRequirements,'this.selectedRequirements')

  }

  isRequirementSelected(requirementId:number):boolean{
    const exists = this.selectedRequirements.includes(requirementId)
    return exists;
  }


  getProofOfPickupAttachment(){

    const proofOfPickupAttachments = this.uploadedAttachmentsArray.filter(
      item => item.attachmentType === 'proofOfPickup'
    );

    return proofOfPickupAttachments;
  }

  getAdditionalAttachment(){

    const additionalAttachments = this.uploadedAttachmentsArray.filter(
      item => item.attachmentType === 'additionalDocument'
    );

    return additionalAttachments;

  }

  async removeDispatchAttachment(file: any) {
    // If saved (has attachmentId), call backend to soft-delete
    if (file?.attachmentId) {
      try {
        this.fullLoaderService.showLoader();
        await this.invoiceService.deleteDispatchAttachment({
          dispatchId: this.dispatchId,
          attachmentId: file.attachmentId,
        });
        this.snack.open('Attachment removed successfully', 'OK', { duration: 3000 });
      } catch (error) {
        console.error('Failed to delete dispatch attachment:', error);
        this.snack.open('Failed to remove attachment. Please try again.', 'OK', { duration: 3000 });
        return;
      } finally {
        this.fullLoaderService.hideLoader();
      }
    }

    // Remove from local array by reference
    const index = this.uploadedAttachmentsArray.indexOf(file);
    if (index > -1) {
      this.uploadedAttachmentsArray.splice(index, 1);
      this.dispatchFormGroup.get('dispatchAttachments')?.setValue([...this.uploadedAttachmentsArray]);
    }
  }

  async fetchDispatchData(){

    this.fullLoaderService.showLoader()

    const data = await this.invoiceService.fetchDispatchDetailsByDispatchIdAndInvoiceId(Number(this.dispatchId), Number(this.invoiceId))
    console.log(data,'data', data.length,data[0].dispatchId)

    if (data && data.length > 0){
    
                
      this.dispatchFormGroup.patchValue({

      
      dispatchId: data[0].dispatchId,
      rfqId: data[0].rfqId,
      quoteId: data[0].quoteId,
      invoiceId: data[0].invoiceId,
      poId: data[0].purchaseOrderId,
      rfqRefNumber: data[0].rfqRefNumber,
      quoteRefNumber: data[0].quoteRefNumber,
      poRefNumber: data[0].purchaseOrderRefNumber,
      invoiceRefNumber: data[0].invoiceNumber,
      supplierDispatchRefNumber: data[0].supplierDispatchRefNo,
      incoterms: data[0].incotermsId,
      dispatchDate: data[0].dispatchDate,
      freightForwarderId: data[0].freightId,
      freightForwarder: data[0].freightForwarder,
      modeOfTransport: data[0].modeOfTransport ? Number(data[0].modeOfTransport) : null,
      awbNumber: data[0].awbNumber,
      trackingLink: data[0].trackingLink,
      dispatchAttachments:data[0].dispatchAttachments || [],
      supplierId: Number(data[0].supplierId)

    });


    this.uploadedAttachmentsArray = data[0].dispatchAttachments || []
    this.selectedRequirements = data[0].requirementId

    }

    this.fullLoaderService.hideLoader()

  }

  async downloadDocFile(filePath: string) {
    this.fullLoaderService.showLoader();
  
    try {
      if (!filePath) return;
  
      const isDataUri = filePath.startsWith('data:');
  
      let extension = 'file';
  
      if (isDataUri) {
        // Extract extension from data URI
        const mimeMatch = filePath.match(/^data:(.*?);base64,/);
        const mimeType = mimeMatch?.[1];
  
        if (mimeType) {
          extension = mimeType.split('/')[1] || 'file';
        }
  
        const name = Math.random().toString(36).substring(2, 10);
        const fileName = `DOC-${name}.${extension}`;
  
        this.downloadFromDataUri(filePath, fileName);
      } else {
        // Handle S3 / normal URL
        extension = filePath?.split('.').pop()?.split('?')[0] || 'file';
        const name = Math.random().toString(36).substring(2, 10);
        const fileName = `DOC-${name}.${extension}`;
  
        await this.dataTransferService.downloadFile(filePath, fileName);
      }
    } finally {
      this.fullLoaderService.hideLoader();
    }
  }

  async downloadFromDataUri(dataUri: string, fileName: string) {
    const byteString = atob(dataUri.split(',')[1]);
    const mimeString = dataUri.split(',')[0].split(':')[1].split(';')[0];
  
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
  
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
  
    const blob = new Blob([ab], { type: mimeString });
  
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
  
    document.body.removeChild(link);
    URL.revokeObjectURL(link.href);
  }





}
